import React from "react";
import classNames from "classnames";
import styles from "../FormField.module.scss";

export interface IPatternFormFieldProps {
  id?: string;
  error?: string;
  name?: string;
  replacePattern?: RegExp;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  checksPresenceName?: (
    e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLElement>,
    name: string,
  ) => void;
}

export const PatternFormField: React.FC<IPatternFormFieldProps> = ({
  id,
  error,
  name,
  readOnly = false,
  registerField,
  isFocused,
  replacePattern = /[^А-Яа-яЁё -]/g,
  onFocus,
  onBlur,
  checksPresenceName,
  autoComplete,
}) => {
  const getInputValue = (value: string) => {
    return value.replace(replacePattern, "");
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (checksPresenceName) {
      checksPresenceName(e, name);
    }
    const input = e.target;
    const inputValue = getInputValue(input.value);
    input.value = inputValue;
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData ?? window["clipboardData"];
    const input = e.target as HTMLInputElement;
    const inputValue = getInputValue(input.value);

    if (pasted) {
      const pastedText = pasted.getData("Text");
      if (replacePattern.test(pastedText)) {
        input.value = inputValue;
      }
    }
  };

  return (
    <input
      {...registerField}
      id={id}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      name={name}
      type="text"
      readOnly={readOnly}
      onInput={handleInput}
      onPaste={handlePaste}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete={autoComplete}
    />
  );
};
